import React, { useState } from 'react'
import CustomHyperLink from '../../components/customHyperLink/CustomHyperLink'
import './footer.css'
import { FooterButton } from './footerButton/footerButton'
import { FooterLink } from './footerLink/footerLink'
import { FooterLogo } from './footerLogo/footerLogo'
import { FooterStars } from './footerStars/footerStars'

import { ReactComponent as Instagram } from '../../assets/img/control/socialMedia/instagram.svg';
import { ReactComponent as Twitter } from '../../assets/img/control/socialMedia/twitter.svg';
import { ReactComponent as Opensea } from '../../assets/img/control/socialMedia/opensea.svg';
import { ReactComponent as Looksrare } from '../../assets/img/control/socialMedia/looksrare.svg';
import { ReactComponent as Discord } from '../../assets/img/control/socialMedia/discord.svg';
export const Footer = () => {
  return (
    <div className='footer'>
        
        
        <div className='footerBottom'>
            <div>Space exploration is a force of nature unto itself that no other force in society can rival.<br></br> - Neil deGrasse Tyson</div> 
            {/* <div>Exoplanet Source Brand (Open Source) 2021 by The 4001 Project. One exoplanet in your wallet is a curiosity. Two are an invasion. <a href='#'> Terms and Conditions.</a></div>  */}
        </div>
    </div>
  )
}
